// src/components/layouts/RouteLoader.jsx
import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";

const LOADER_HEIGHT = 3; // px

const RouteLoader = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const timeoutRef = useRef(null);

  useEffect(() => {
    // Start loader on location change
    setLoading(true);
    setProgress(0);

    // Animate to 90% quickly, then to 100% on complete
    timeoutRef.current = setTimeout(() => setProgress(90), 100);

    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, [location]);

  useEffect(() => {
    if (!loading) return;

    // When loading is true, wait for a short time, then finish
    const finish = setTimeout(() => {
      setProgress(100);
      // Hide loader after short delay
      setTimeout(() => setLoading(false), 300);
    }, 500); // Adjust as needed for your app's speed

    return () => clearTimeout(finish);
  }, [loading, location]);

  return (
    loading && (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: `${progress}%`,
          height: LOADER_HEIGHT,
          background: "#E96F3A",
          zIndex: 9999,
          transition: "width 0.3s cubic-bezier(0.4,0,0.2,1)",
          pointerEvents: "none",
        }}
      />
    )
  );
};

export default RouteLoader;